<button (click)="toggleOverlay()" [class.primary]="primaryButton()">
  <cue-icon [icon]="cueNewReservation" />
  <p>
    {{ translation.menu.reserveButton | transloco }}
  </p>
</button>
